import * as Constants from '../constants/redux';

const OnboardingActions = {
  setActiveBeacons: (ids) => (dispatch) =>
    dispatch({
      type: Constants.ONBOARDING_TUTORIAL_BEACONS_SET,
      ids,
    }),
  setActiveTutorial: (name) => (dispatch) =>
    dispatch({
      type: Constants.ONBOARDING_TUTORIAL_ACTIVE_SET,
      name,
    }),
  setOnboardingData: (onboarding) => (dispatch) =>
    dispatch({
      type: Constants.ONBOARDING_DATA_SET,
      onboarding,
    }),
};

export default OnboardingActions;
